import { GenerationTask } from 'Tasks/GenerationTask/GenerationTask.ts'
import { ITask } from 'Core/TaskAdapter.ts'
import { ContainerType, TaskConfigType } from 'Types/Tasks.types.ts'

export class SummarisationTask
    extends GenerationTask
    implements ITask<TaskConfigType<ContainerType, unknown>> {}
